import authRules from '../authRules.js';


const postedSchedules = (user) => {
  const { mySchedule, lastPostings } = user.securityLevels;
  if (
    mySchedule >= authRules.postedSchedules.mySchedule
    ) {
      return true;
  } else {
      return false;
    }
  }


export default postedSchedules;
